export * from './IconMoneyHand';
export { default as IconMoneyHand } from './IconMoneyHand';
